import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const treatmentPlanChartContainerStyle = css`
  display: flex;
  gap: ${theme.spacing(0.5)};
  justify-content: space-between;

  @container (min-width: 470px) {
    gap: ${theme.spacing(2)};
  }

  > div {
    max-width: calc(100% / 3 - ${theme.spacing(0.5)});
    overflow: hidden;

    @container (min-width: 470px) {
      max-width: calc(100% / 3 - ${theme.spacing(2)});
    }
  }
`;
